import { REDMARKLOGS } from "../actions/actionTypes";

const INITIAL_STATE = {
  data: [],
  end: false,
  error: null,
  form: null,
  formLoading: false,
  limit: 10,
  loading: false,
  offset: 0,
};

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action;

  switch (type) {
    case REDMARKLOGS.SETFORM:
      return { ...state, form: payload };
    case REDMARKLOGS.SETFORMPROP:
      return { ...state, form: { ...state.form, [payload.key]: payload.value } };

    case REDMARKLOGS.FETCH.REQUEST:
      return { ...state, ...payload, loading: true };
    case REDMARKLOGS.FETCH.SUCCESS:
      let redmarkLogs = [...state.data, ...payload.data];

      if (payload.id) return { ...state, form: payload.data, error: null, loading: false };
      return { ...state, data: redmarkLogs, end: payload.end, error: null, loading: false };
    case REDMARKLOGS.FETCH.FAILURE:
      return { ...state, error: payload, loading: false };

    case REDMARKLOGS.EDIT.REQUEST:
      return { ...state, formLoading: true, error: null };
    case REDMARKLOGS.EDIT.SUCCESS:
      return {
        ...state,
        data: payload.id ? [...state.data] : [payload.data, ...state.data],
        error: null,
        formLoading: false,
        form: payload.data,
      };
    case REDMARKLOGS.EDIT.FAILURE:
      return { ...state, error: payload, formLoading: false };

    case REDMARKLOGS.SAVE.REQUEST:
      return { ...state, formLoading: true, error: null };
    case REDMARKLOGS.SAVE.SUCCESS:
      return {
        ...state,
        data: state.data.map((d) => (d.id.toUpperCase() === payload.id.toUpperCase() ? payload : d)),
        error: null,
        form: null,
        formLoading: false,
      };
    case REDMARKLOGS.SAVE.FAILURE:
      return { ...state, action: null, error: payload, formLoading: false };

    case REDMARKLOGS.RESET:
      return { ...state, data: [], end: false, form: null };

    default:
      return state;
  }
};
